<template>
  <div>
    <div class="fix-gradient">
      <div class="payment">{{FORMATED_BREAKDOWN_PAYMENT}}</div>
    </div>
    <div class="slide-item">
      <div class="subtitle">YOUR ESTIMATED MONTHLY PAYMENT</div>
      <Slider
        class="slider"
        :max="max"
        :min="min"
        :value="state.EXTRA_MONTHLY_PAYMENT_AMOUNT"
        :update="updateExtraMonthlyPayment"
        :interval="interval"
      ></Slider>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import Slider from "./util/Slider";

// import "vue-slider-component/theme/antd.css";
import { STATE, MUTATIONS, GETTERS, ACTIONS } from "../storeConstants";
import { currency } from "../util/format";

const { CHANGE_EXTRA_MONTHLY_PAYMENT_AMOUNT } = MUTATIONS;
const {
  FORMATED_PAYMENT_AND_EXTRA,
  EXTRA_PAYMENT,
  FORMATED_BREAKDOWN_PAYMENT
} = GETTERS;
const {
  EXTRA_MONTHLY_PAYMENT_AMOUNT,
  MODIFY_TERM,
  TERM,
  INTEREST_RATE,
  PRINCIPLE,
  DOWNPAYMENT
} = STATE;

export default {
  data(){
    return {
      max: 100000,
      min: 0,
      interval: 1
    };
  },
  computed: {
    ...mapState({
      state: state => state.base
    }),
    ...mapGetters([
      FORMATED_PAYMENT_AND_EXTRA,
      FORMATED_BREAKDOWN_PAYMENT,
      EXTRA_PAYMENT
    ])
  },
  methods: {
    ...mapMutations([CHANGE_EXTRA_MONTHLY_PAYMENT_AMOUNT]),
    updateExtraMonthlyPayment: function(value) {
      this.CHANGE_EXTRA_MONTHLY_PAYMENT_AMOUNT({
        target: "EXTRA_MONTHLY_PAYMENT_AMOUNT",
        value
      });
    }
  },
  components: {
    Slider: Slider
  }
};
</script>
<style>
@import url("../../node_modules/vue-slider-component/theme/antd.css");
@import url("../../node_modules/vue-slider-component/dist-css/vue-slider-component.css");
</style>
<style scoped lang="scss">
@mixin gradient-text($start-color, $end-color, $fallback: #000) {
  color: $fallback;
  @supports (background-clip: text) {
    color: transparent;
    background-image: linear-gradient(to right, $start-color, $end-color),
      linear-gradient(to bottom, #fff, #fff);
    -webkit-background-clip: text;
    background-clip: text;
  }
}

.slide-item {
  width: 100%;
}
.fix-gradient {
  align-items: center;
  justify-content: center;
  display: flex;
}
.estimated-payment {
  display: flex;
  flex-direction: column;
}
.payment {
  @include gradient-text(#60c5b7, #acd14c);

  font-size: 52px;
  text-align: center;
  font-family: "Poppins", sans-serif;
}
.subtitle {
  font-size: 14px;
  font-family: "Poppins", sans-serif;
  color: #808080;
  text-align: center;
  width: 100%;
  margin-bottom: 19px;
}
.slider {
  @media (min-width: 768px) {
    width: 60% !important;
  }
  @media (min-width: 768px) {
    width: 90% !important;
  }
  margin: auto;
}
</style>